import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import Vuex from 'vuex'

import '@mdi/font/css/materialdesignicons.css' // Ensure you are using css-loader

Vue.use(Vuetify);
Vue.use(Vuex)

export default new Vuetify({
  icons: {
    iconfont: 'mdi', // default - only for display purposes
  },
  theme: {
    options: {
      customProperties: true,
    },
    themes: {
      light: {
        background: '#F3F6F9',
        background_grey: '#696969',
        quickest:'#EF414B',
        quicker:'#E69147',
        quick:'#EECB37',
        primary: '#25316A',
        secondary: '#b0bec5',
        accent: '#25316A',
        error: '#E86674',
        orange: '#FF7A0D',
        golden: '#A68C59',
        badge: '#20355A',

        action_buttontext:'#20355A',

        toptap: '#20355A',
        toptaptext: '#FFFFFF',
        searchtapbg:'#EDEDED',
        toptaphamburger: '#3D5277',
        topheadsystem:'#20355A',
        openbottom:'#344768',
        status_text_worklist: '#9d9d9d',
        title_column_worklist:'#9d9d9d',
        content_column_worklist:'#9d9d9d',
        recieve_date_worklist:'#9d9d9d',

        create_button:'#20355A',
        search_button:'#20355A',
        fab_button:'#20355A',
        add_button:'#20355A',
        process_buttontext:'#20355A',
        

        footer:'#2B74A9',

      },
      dark: {
        primary: '#085294',
      }
    },
    // ...
  },
});
